<template>
    <div class="popup" :class="{active: show}">
        <div class="in">
            <div class="btn_close" @click="closePopup"></div>
            <div class="box">
                <div class="item">
                    <div class="content">{{$t('selectText')[0].text}}</div>
                    <router-link class="btn" v-if="APP_NAME == 'seoul'" to="/iframe/contact" target="_blank" @click.native="$trackEvent('submit-enquiry')">{{$t('selectText')[0].btn}}</router-link>
                    <router-link class="btn" v-else to="/iframe/admissions" target="_blank" @click.native="$trackEvent('submit-enquiry')">{{$t('selectText')[0].btn}}</router-link>
                </div>
                <div class="item">
                    <div class="content">{{$t('selectText')[1].text}}</div>
                    <router-link class="btn" to="/iframe/apply" target="_blank" @click.native="$trackEvent('submit-application')">{{$t('selectText')[1].btn}}</router-link>
                </div>
                <div class="item">
                    <div class="content">{{$t('selectText')[2].text}}</div>
                    <!-- <div class="btn">Select Age Group</div> -->
                    <div class="select" :class="{active: isShowSelect}">
                        <div class="name" @click="isShowSelect = !isShowSelect">{{$t('selectText')[2].btn}}</div>
                        <div class="options">
                            <!-- <div class="option" @click="showYearsPopup(0)">DUCKS</div>
                            <div class="option" @click="showYearsPopup(1)">Junior School</div>
                            <div class="option" @click="showYearsPopup(2)">Senior School</div> -->
                            <div class="option" v-for="(item, index) in years" :key="index" @click="showYearsPopup(index)">{{item[lange('name')]}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
    name: "selectPopup",
    props: ['show'],
    data() {
        return {
            isShowSelect: false,
            APP_NAME: process.env.VUE_APP_NAME,
        };
    },
    computed: {
        ...mapState(['years']),
        lange(){
            return (name)=>{
                if(this.$i18n.locale == 'en'){
                    return `en_${name}`
                }else{
                    return name
                }
            }
        }
    },
    components: {
        
    },
    mounted() {},
    watch: {},
    methods: {
        closePopup(){
            this.$emit('close');
        },
        showYearsPopup(index){
            this.$store.state.isShowYearsPopup = true;
            this.$store.state.yearPageActiveIndex = 1;
            this.$store.state.yearsActiveIndex = index;
            
            // trackEvent
            let gaLabels = ['continue-ducks', 'continue-js', 'continue-ss'];
            // 新加坡有四个
            // if (this.schoolName == 'singapore') { 
            //     gaLabels.push('continue-te');
            // }
            this.$trackEvent(gaLabels[index]);
        },
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.popup{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: .6);
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    transition: opacity .3s, visibility .3s;
    &.active{
        opacity: 1;
        visibility: visible;
    }
    .in{
        width: 8.6rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .btn_close{
            width: .4rem;
            height: .4rem;
            border-radius: 50%;
            background: rgba($color: #000000, $alpha: 0.8);
            position: absolute;
            top: 0;
            right: -0.5rem;
            cursor: pointer;
            &::before,
            &::after{
                content: "";
                width: .2rem;
                height: .02rem;
                background: #fff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
        .box{
            display: flex;
            justify-content: space-between;
            $color: (
                1: #97d701,
                2: #ff5100,
                3: #6d2e52,
            );
            .item{
                width: 2.8rem;
                height: 2.8rem;
                border-radius: .1rem;
                padding: .2rem;
                display: flex;
                flex-direction: column;
                @for $i from 1 through 3{
                    &:nth-of-type(#{$i}){
                        background: map-get($color, $i);
                        .btn,
                        .select{
                            color: map-get($color, $i);
                        }
                        .select.active .name{
                            background: map-get($color, $i);
                        }
                    }
                }
                .content{
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: .24rem;
                    text-align: center;
                }
                .btn,
                .select .name{
                    background: #fff;
                    border-radius: .1rem;
                    height: .5rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
                .btn,
                .select{
                    width: 100%;
                    font-weight: bold;
                    font-size: .18rem;
                }
                .select{
                    position: relative;
                    .name{
                        border-radius: .1rem;
                        border: .02rem solid #fff;
                    }
                    &.active{
                        background: #fff;
                        border-radius: .1rem .1rem 0 0;
                        .name{
                            color: #fff;
                            &::after{
                                border-color: #fff;
                            }
                        }
                        .options{
                            display: block;
                        }
                    }
                    .name{
                        display: flex;
                        align-items: center;
                        &::after{
                            content: "";
                            display: block;
                            margin-left: .1rem;
                            margin-top: -.04rem;
                            width: .1rem;
                            height: .1rem;
                            border-right: 2px solid #6d2e52;
                            border-bottom: 2px solid #6d2e52;
                            transform: rotate(45deg);
                        }
                    }
                    .options{
                        position: absolute;
                        top: 100%;
                        left: 0;
                        right: 0;
                        padding: .10rem 0;
                        background: #fff;
                        border-radius: 0 0 .1rem .1rem;
                        display: none;
                        .option{
                            margin: .07rem 0;
                            height: .30rem;
                            font-weight: bold;
                            line-height: .30rem;
                            text-align: center;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 640px) {
        .in{
            width: 6rem;
            .btn_close{
                width: .5rem;
                height: .5rem;
                right: -.6rem;
            }
            .box{
                flex-direction: column;
                .item{
                    width: 100%;
                    height: 2.6rem;
                    margin-bottom: .5rem;
                    padding: .3rem;
                    .btn,
                    .select .name{
                        height: .6rem;
                    }
                    .btn,
                    .select{
                        font-size: .24rem;
                    }
                    .content{
                        font-size: .3rem;
                    }
                    .select{
                        .options{
                            .option{
                                height: .4rem;
                                margin: .1rem 0;
                                line-height: .4rem;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>